import { extractActionName } from '@/components/FixtureTabs/helpers/extractActionName';
import { FixtureAction } from '@/service/types';
import { ActionFiterType } from '@/components/ActionsTable/ActionFilters/Template/types';
import { formatDate } from '../formatDate/formatDate';

interface GenerateSubTitleProps {
  action: FixtureAction;
  actionTypesCurrentSport?: ActionFiterType[];
}

export const generateSubTitleDialog = ({
  action,
  actionTypesCurrentSport,
}: GenerateSubTitleProps) =>
  `${action.fixtureSeqNum} - ${extractActionName(
    action.fixtureActionTypeId,
    actionTypesCurrentSport,
  )} - ${action.clockTimeString} (${formatDate(action.timestamp)})`;
